import React from "react";

import { HStack } from "@/components/ui";

import FollowersButton from "./followers-button";
import FollowingButton from "./following-button";

import type { Account } from "@/schemas";

interface ProfileStatsProps {
  account: Account;
  onClickHandler?(event: React.MouseEvent): void;
  textSize?: "sm" | "md";
}

/** Display follower and following counts for an account. */
export default function ProfileStats(props: ProfileStatsProps) {
  return (
    <HStack alignItems="center" space={3}>
      <FollowersButton {...props} />
      <FollowingButton {...props} />
    </HStack>
  );
}
